import { z } from "zod";

export const createSessionResponseSchema = z.object({
  sessionToken: z.string().min(32),
  expiresAt: z.string().datetime(),
});

export type CreateSessionResponse = z.infer<typeof createSessionResponseSchema>;

export const heartbeatResponseSchema = z.object({
  expiresAt: z.string().datetime(),
});

export type HeartbeatResponse = z.infer<typeof heartbeatResponseSchema>;

export const cleanupSessionResponseSchema = z.object({
  deleted: z.literal(true),
});
